<template>
        <router-view> </router-view>
</template>
<script>
import { mapGetters } from "vuex";
export default {
    unmounted() {
        this.$store.dispatch("clearProductStepValues");
    },
    components: {},
    computed: {
        ...mapGetters(["products"]),
    },
    name: "products",
};
</script>

<style></style>
